// Import Bugsnag and the Angular integration
import Bugsnag from '@bugsnag/js'
import { BugsnagErrorHandler } from '@bugsnag/plugin-angular'
import { NgModule, ErrorHandler } from '@angular/core'
import { environment } from "../environments/environment";

var envStage = environment.production ? 'production' : environment.staging ? 'staging' : 'development';

// configure Bugsnag asap
Bugsnag.start( {
	apiKey: environment.bugsnagId,
	enabledReleaseStages: ['production', 'staging'],
	releaseStage: envStage,
} )

// create a factory which will return the Bugsnag error handler
export function errorHandlerFactory() {
	return new BugsnagErrorHandler()
}

import { BrowserModule } from '@angular/platform-browser';
import { AppComponent } from './app.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { HttpClientModule } from '@angular/common/http';
import { ApiService } from './services/api.service';
import { TrackingService } from './services/tracking.service';

// Material
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from "@angular/material/select";
import { MatRadioModule } from "@angular/material/radio";
import { MatIconModule } from "@angular/material/icon";
import { MatDatepickerModule } from '@angular/material/datepicker';
import { ErrorStateMatcher, MatNativeDateModule, ShowOnDirtyErrorStateMatcher } from '@angular/material/core';
import { MatDialogModule } from '@angular/material/dialog';
import { MAT_FORM_FIELD_DEFAULT_OPTIONS, MatFormFieldModule } from '@angular/material/form-field';

// Template Components

// Form parts
import { HeaderComponent } from './parts/header/header.component';
import { FooterComponent } from './parts/footer/footer.component';
import { ProgressBarComponent } from './parts/progress-bar/progress-bar.component';

// Form steps
import { MovingFromComponent } from './form-steps/moving-from/moving-from.component';
import { MovingToComponent } from './form-steps/moving-to/moving-to.component';
import { MovingSizeComponent } from './form-steps/moving-size/moving-size.component';
import { MovingContentComponent } from './form-steps/moving-content/moving-content.component';
import { MovingBoxesComponent } from './form-steps/moving-boxes/moving-boxes.component';
import { PropertyTypeFromComponent } from './form-steps/property-type-from/property-type-from.component';
import { PropertyTypeToComponent } from './form-steps/property-type-to/property-type-to.component';
import {
	MovingDateComponent,
	customDatePickerHeader
} from './form-steps/moving-date/moving-date.component';
import { NameEmailPhoneComponent } from './form-steps/name-email-phone/name-email-phone.component';

import { VolumeCalculatorComponent } from './form-parts/volume-calculator/volume-calculator.component';
import { APP_BASE_HREF, DatePipe } from "@angular/common";
import { MatButtonModule } from "@angular/material/button";
import { BackgroundComponent } from './parts/background/background.component';
import { ThankYouComponent } from './thank-you/thank-you.component';
import { MatCheckboxModule } from "@angular/material/checkbox";
import { PossibleMatchesComponent } from './form-parts/possible-matches/possible-matches.component';
import { A11yModule } from "@angular/cdk/a11y";
import { PropertyTypeDetailsFromComponent } from './form-steps/property-type-details-from/property-type-details-from.component';
import { PropertyTypeDetailsToComponent } from './form-steps/property-type-details-to/property-type-details-to.component';
import { CurrencyExchangeComponent } from './form-third-party-questions/currency-exchange/currency-exchange.component';
import { UtilitiesComponent } from './form-third-party-questions/utilities/utilities.component';
import { HealthInsuranceComponent } from './form-third-party-questions/health-insurance/health-insurance.component';
import { ChooseServicesComponent } from './form-third-party-questions/choose-services/choose-services.component';
import { RealEstateComponent } from './form-third-party-questions/real-estate/real-estate.component';

@NgModule( {
    declarations: [
        AppComponent,
        // Form parts
        HeaderComponent,
        FooterComponent,
        ProgressBarComponent,
        // Form steps
        MovingFromComponent,
        MovingToComponent,
        MovingSizeComponent,
        MovingContentComponent,
        MovingDateComponent,
        NameEmailPhoneComponent,
        VolumeCalculatorComponent,
        customDatePickerHeader,
        BackgroundComponent,
        ThankYouComponent,
        PossibleMatchesComponent,
        PropertyTypeFromComponent,
        PropertyTypeToComponent,
        PropertyTypeDetailsFromComponent,
        PropertyTypeDetailsToComponent,
        MovingBoxesComponent,
        CurrencyExchangeComponent,
        UtilitiesComponent,
        HealthInsuranceComponent,
        ChooseServicesComponent,
        RealEstateComponent,
    ],
    imports: [
        BrowserModule,
        ReactiveFormsModule,
        BrowserAnimationsModule,
        HttpClientModule,
        // Material imports
        MatInputModule,
        MatFormFieldModule,
        MatSelectModule,
        MatRadioModule,
        MatIconModule,
        MatDatepickerModule,
        MatNativeDateModule,
        MatDialogModule,
        MatButtonModule,
        MatCheckboxModule,
        FormsModule,
        A11yModule,
    ],
    providers: [
        { provide: ErrorHandler, useFactory: errorHandlerFactory },
        ApiService,
        MatDatepickerModule,
        MatNativeDateModule,
        TrackingService,
        DatePipe,
        {
            provide: MAT_FORM_FIELD_DEFAULT_OPTIONS,
            useValue: {
                appearance: 'outline',
                hideRequiredMarker: true
            }
        },
        { provide: APP_BASE_HREF, useValue: './' },
        { provide: ErrorStateMatcher, useClass: ShowOnDirtyErrorStateMatcher }
    ],
    bootstrap: [AppComponent]
} )
export class AppModule {
}
